import { UserManager } from 'oidc-client-ts';

export class OidcUserManager extends UserManager {
  public async refreshToken(): Promise<void> {
    const user = await super.getUser();
    if (!user) {
      throw new Error('User has not logged in');
    }

    const { refresh_token, id_token, scope, session_state, state: data, profile } = user;
    if (!refresh_token || !id_token || !scope) {
      throw new Error('Refresh token not issued to user');
    }

    await super._useRefreshToken({
      refresh_token,
      id_token,
      scope,
      session_state,
      data,
      profile
    });
  }
}
